<template>
  <div class="right_body_s" v-loading="isLoading">
    <Panel>
      <template v-slot:panel-top>
        <ToolBar
          class="infoActive_rumb"
          :sdata="sdata"
          @edit="onEditUnit"
          @add="onAddUnit"
          @del="del"
          @restore="restore"
          isAdd
          isEdit
          isDelStatus
        >
          <!-- <span
            class="btn infoRight_sub_btn del_btn"
            style="margin-right:95px"
            @click.stop="onSubCheck"
          >检查数据</span>
          <span class="btn infoRight_sub_btn save_btn" @click.stop="onSubSave">提交数据</span>-->
        </ToolBar>
      </template>
      <template v-slot:panel-main>
        <FormGridPanel
          :tableColumns="columns"
          @EdUnitId="getEdUnitId"
          @DelUnit="DelUnit"
          @RestoreUnit="RestoreUnit"
          @cellClick="cellClick"
          ref="FormGridPanel"
        ></FormGridPanel>
      </template>
    </Panel>
    <el-dialog
      customClass="customWidth"
      :title="title"
      :visible.sync="isShowMaterialDialog"
      @close="cancelSelect"
      v-dialogDrag
    >
      <v-content class="contnet_box" :fromData="fromData" @CompanyData="getCompanyData" ref="content"></v-content>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelect">取 消</el-button>
        <el-button type="primary" @click="selectMattersOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import vContent from "./ui/UnitNeWindow.vue";
import ToolBar from "components/btn/listBtn.vue";
import FormGridPanel from "components/grid/UnitFormGridPanel.vue";
import Panel from "components/container/BasePanel.vue";
import { URL } from "./service/UnitManage.service.js";
import { UnitmanageApi } from "api/base.js";

export default {
  components: { ToolBar, vContent, Panel, FormGridPanel },
  data() {
    return {
      sdata:{},
      columns: [
        { type: "radio", title: "选择", width: 60, fixed: "left" },
        { type: "seq", width: 80, title: "序号", fixed: "left" },
        {
          field: "companyCode",
          title: "公司编码",
          editRender: { name: "input" }
        },
        {
          field: "companyName",
          title: "公司描述",
          editRender: { name: "input" }
        },
        {
          field: "unitCode",
          title: "单位编码",
          editRender: { name: "input" }
        },
        // 单元格渲染，自动读取字典配置
        {
          field: "unitDesc",
          title: "单位描述",
          editRender: { name: "input" }
        },
        {
          field: "maintainStatus",
          title: "单位状态",
          editRender: { name: "input" },
          formatter(row) {
            return row.row.maintainStatus == "X" ? "已删除" : "未删除";
          }
        }
        
      ],
      isShowMaterialDialog: false,
      formLabelWidth: "100px",
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      fromData: {
      },
      title: ""
    };
  },
  created() {
    this.loadResourceDataset();
  },
  updated: function() {},
  methods: {
    //子组件向父组件传过来的,修改时用
    async getEdUnitId(data) {
      console.log(data);
      if (data) {
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$get(UnitmanageApi.find, {
          unitId: data
        });
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        console.log(res);
        if (res.status && res.data) {
          this.fromData = res.data;
          this.title = "修改计量单位";
          this.isShowMaterialDialog = true;
        } else {
          this.$message.error("操作失败，请重试！");
        }
      } else {
        this.$message.error("请选择需要修改的计量单位信息！");
      }
    },
    //子组件向父组件传过来的,删除时用
    async DelUnit(data){
      console.log(data)
      this.sdata = data
      if (data) {
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
        this.changeDataStatus(UnitmanageApi.del," 删除成功！","X",data.unitId);
      }).catch(() => {});
        // this.isLoading = true;
        // this.loadingBg = "rgba(255,255,255,0.5)";
        // this.loadingTxt = "数据处理中...";
        // let res = await this.$get(MatcatmanageApi.del, {
        //   materialGroupId: data.materialGroupId
        // });
        // let json = JSON.stringify(this.fromData);
        // console.log(json);
        // this.isLoading = false;
        // console.log(res);
        // if (res.status && res.data) {
        //   this.$message.success(res.msg);

        // } else {
        //   this.$message.error("操作失败，请重试！");
        // }
      } else {
        this.$message.error("请选择需要删除的信息！");
      }
    },
    //子组件向父组件传过来的,恢复删除时用
    async RestoreUnit(data){
      console.log(data)
      this.sdata = data
      if (data) {
      this.$confirm('确定恢复这条记录, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
        this.changeDataStatus(UnitmanageApi.restore," 恢复成功！","",data.unitId);
      }).catch(() => {});
        // this.isLoading = true;
        // this.loadingBg = "rgba(255,255,255,0.5)";
        // this.loadingTxt = "数据处理中...";
        // let res = await this.$get(MatcatmanageApi.del, {
        //   materialGroupId: data.materialGroupId
        // });
        // let json = JSON.stringify(this.fromData);
        // console.log(json);
        // this.isLoading = false;
        // console.log(res);
        // if (res.status && res.data) {
        //   this.$message.success(res.msg);

        // } else {
        //   this.$message.error("操作失败，请重试！");
        // }
      } else {
        this.$message.error("请选择需要恢复的信息！");
      }
    },
    cellClick(data){
        this.$set(this.sdata,'maintainStatus',data.maintainStatus);
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status,data){
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      let res = await this.$get(api,{unitId:data});
      this.isLoading = false;
      if(res.status){
        this.$refs.FormGridPanel.getList();
        this.$message.success("计量单位 " + data + message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
      }
    },
    /**
     * 加载资源列表
     */
    async loadResourceDataset() {},
    /**
     * 触发添加资源
     */
    onAddUnit() {
      this.title = "新增计量单位";
      this.isShowMaterialDialog = true;
    },
    /**
     * 编辑
     */
    onEditUnit() {
      this.$refs.FormGridPanel.onEditUnit();
    },
    //删除
    del(){
      this.$refs.FormGridPanel.onDelUnit();
      // let vm = this;
      // if(!this.sdata.materialId){
      //   this.$message.error('请选择需要删除的记录');
      //   return;
      // }
      // this.$confirm('确定删除这条记录, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.changeDataStatus(matterApi.del,"删除成功！","X");
      // }).catch(() => {});
    },
    //恢复删除
    restore(){
      this.$refs.FormGridPanel.onRestoreUnit();
      // let vm = this;
      // if(!this.sdata.materialId){
      //   this.$message.error('请选择需要恢复的物料');
      //   return;
      // }
      // this.$confirm('恢复此记录, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      // .then(() => {
      //     this.changeDataStatus(matterApi.restore,"修改成功！","");
      // });
    },
    cancelSelect() {
      this.fromData = {};
      this.isShowMaterialDialog = false;
    },
    async selectMattersOk() {
      this.$refs.content.validataForm();
      let baseRes = this.fromData.regRes;
      if (!baseRes) return;
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";

      let unitId = this.fromData.unitId;
      var postUrl = UnitmanageApi.add;
      if (unitId) postUrl = UnitmanageApi.modify;
      let res = await this.$post(postUrl, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      this.isLoading = false;
      console.log(res);
      if (res.status) {
        let successMsg = unitId
          ? "计量单位 " + res.data.unitId + "修改成功"
          : "计量单位 " + res.data.unitId + " 已添加成功";
        this.$alert(successMsg, "操作提示", {
          confirmButtonText: "确定",
          type: "success",
          callback: action => {
            this.fromData = {};
            this.$refs.FormGridPanel.getList();
          }
        });
      } else {
        this.$message.error(res.errorMsg);
      }
      this.isShowMaterialDialog = false;
      this.fromData = {};
    },
    getCompanyData(companyRow){
        console.log(companyRow)
        if(companyRow){
               this.fromData.companyId=companyRow.companyId;
               this.fromData.companyCode=companyRow.companyCode;
               this.fromData.companyName=companyRow.companyName;
           }
    }
    /**
     * 检查数据
     */
    // onSubCheck() {},
    /**
     * 提交数据
     */
    // async onSubSave() {

    // }
  }
};
</script>
